//src/services/adminNotifications.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminNotifications = () => {
  return adminApiRequest("/notifications");
};

export const markNotificationRead = (id) => {
  return adminApiRequest(`/notifications/${id}/read`, {
    method: "POST",
  });
};

export const deleteNotification = (id) => {
  return adminApiRequest(`/notifications/${id}`, {
    method: "DELETE",
  });
};

export const getUnreadNotificationsCount = () => {
  return adminApiRequest("/notifications/count/unread");
};
